import { gql } from 'apollo-angular';

export const DeleteOrderDocument = gql`
  mutation deleteOrder($orderId: String!) {
    deleteOrder(orderId: $orderId)
  }
`;
